import React, { useEffect, useState } from "react";
import "./SocialLogin.scss";
import { selectIcon, SVG } from "../UI/selector";
import { loginSignup } from "../../services/CallApi";
import { ErrorUI } from "../UI/Modals/Modals";
import { messageService } from "../../services/subscriberService";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { UniqueID, env } from "../../services/CommonFunction";

export default function SocialLogin({}) {
  const [FBToken, setFBToken] = useState(null);
  const [apple, setApple] = useState(null);
  const { hash } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (FBToken) {
      window.FB.api(
        "/me",
        "GET",
        { fields: "first_name,last_name,email,picture", access_token: FBToken },
        (response) => {
          console.info(response);
          if (
            !response.error &&
            response.first_name &&
            response.last_name &&
            response.email &&
            response.picture
          ) {
            loginSignup(
              {
                first_name: response.first_name,
                last_name: response.last_name,
                email: response.email,
                profile_pic_original: response.picture.data.url,
                profile_pic_thumb: response.picture.data.url,
              },
              "facebookSignupLogin",
              { access_token: FBToken }
            ).then((res) => {
              console.info(res);
              if (res.status) {
                history.push({ pathname: "/" });
              } else {
                ErrorUI(res.list);
              }
            });
          } else {
            ErrorUI("Failed to continue with facebook, please try again.");
          }
        }
      );
    } else if (hash) {
      const accessToken = hash.split("&")[0].split("=")[1];
      setFBToken(accessToken);
    }
  }, [FBToken]);

  const continueWithFB = () => {
    window.sessionStorage.removeItem("fbssls_229701104963045");
    window.FB.getLoginStatus(function (response) {
      console.info(response);
      if (response.status === "connected") {
        setFBToken(response.authResponse.accessToken);
      } else {
        window.location =
          "https://www.facebook.com/v18.0/dialog/oauth?client_id=229701104963045&redirect_uri=" +
          window.location.href +
          "&scope=public_profile,email&response_type=token&state={st=state123abc,ds=123456789}}";
      }
    });
  };

  useEffect(() => {
    const currentURL = new URL(window.location.href);
    if (apple) {
      try {
        const signupData = {
          apple_user_id: apple.apple_user_id,
          email: apple.email,
        };
        if (apple.first_name) {
          signupData.first_name = apple.first_name;
          signupData.last_name = apple.last_name;
        }
        loginSignup(signupData, "appleSignupLogin").then((res) => {
          console.info(res);
          if (res.status) {
            history.push({ pathname: "/" });
          } else {
            ErrorUI(res.list);
          }
        });
      } catch (error) {
        console.info(error);
        ErrorUI("Failed to continue with Apple ID, please try again.");
      }
    } else if (
      currentURL.searchParams.get("user_identifier") &&
      currentURL.searchParams.get("user_identifier") ===
        localStorage.getItem("apple_user_identifier")
    ) {
      setApple({
        apple_user_id: currentURL.searchParams.get("apple_user_id"),
        email: currentURL.searchParams.get("email"),
        first_name: currentURL.searchParams.get("first_name"),
        last_name: currentURL.searchParams.get("last_name"),
        user_identifier: currentURL.searchParams.get("user_identifier"),
      });
    }
  }, [apple]);

  const continueWithAppleID = async () => {
    const uid = UniqueID() + new Date().toISOString();
    localStorage.setItem("apple_user_identifier", uid);
    const state = JSON.stringify({
      subdomain: window.location.origin + "/SignIn",
      user_identifier: uid,
    });
    await window.AppleID.auth.signIn({
      clientId: "fitness.tribe.member",
      scope: "name email",
      redirectURI: env("Urls") + "v1/member/apple-web-signup-callback",
      state: state,
      nonce: "[NONCE]",
      usePopup: false,
    });
  };
  return (
    <div className="socialLoginContainer">
      <button
        type="button"
        className="FBButton"
        onClick={() => continueWithFB()}
      >
        <SVG src={selectIcon("facebookIcon")} />
        Continue with Facebook
      </button>
      <button
        type="button"
        className="AppleButton"
        onClick={() => continueWithAppleID()}
      >
        <SVG src={selectIcon("appleIcon")} />
        Continue with Apple
      </button>
    </div>
  );
}
